/** People: the list behind the header icon. Tagging happens on the show sheet. */
import { getJson, send } from "./request";
import type { Person } from "./types";

export { fetchPeople } from "./showSheet";

export const addPerson = (name: string, email: string) =>
  send<{ id: number }>("/api/people", "POST", { name: name.trim(), email: email.trim() || null }, "Could not add them");
export const editPerson = (id: number, name: string, email: string, hidden: boolean) =>
  send(`/api/people/${id}`, "PUT", { name: name.trim(), email: email.trim() || null, hidden }, "Could not save");
export const deletePerson = (id: number) => send(`/api/people/${id}`, "DELETE", undefined, "Could not delete them");
export const fetchPersonShows = async (id: number) =>
  (await getJson<{ shows: { id: number; date: string; venue: string; number: number }[] }>(`/api/people/${id}/shows`, "Could not load their shows")).shows;

/** Name search, most shows together first, then by name. */
export function visiblePeople(people: Person[], q: string): Person[] {
  const needle = q.trim().toLowerCase();
  return people
    .filter((p) => !needle || p.name.toLowerCase().includes(needle))
    .sort((a, b) => b.shows - a.shows || a.name.localeCompare(b.name));
}

export const SHOWS_TOGETHER_PREVIEW = 12;

/** The person sheet's show list: the first few until "Show all" is on, and how many that leaves out. */
export function showsTogether<T>(shows: T[], all: boolean): { rows: T[]; more: number } {
  const rows = all ? shows : shows.slice(0, SHOWS_TOGETHER_PREVIEW);
  return { rows, more: shows.length - rows.length };
}
